<template>
  <div>
    <div class="has-text-centered">
      <figure class="image is-88x88 is-inline-block">
        <img :src="require('@/assets/lawn_treatment/confirmation.png')" />
      </figure>
      <p>You’re all set! We’ve received your request.</p>
      <LsButton
        text="My Dashboard"
        track-id="add_lawn_treatment-my_dashboard"
        :is-uppercase="false"
        bg-color="primary"
        class="my-dashboard"
        @click="$router.push({ name: 'services' })"
      />
    </div>
  </div>
</template>

<script>
import LsButton from '@/components/common/LsButton/LsButton.vue';

export default {
  name: 'LawnTreatmentConfirmationViewComponent',
  components: { LsButton },
};
</script>

<style lang="scss" scoped>
img {
  width: 88px;
}

p {
  font-size: 16px;
  line-height: 24px;
  list-style-type: disc;
  margin: 42px 0 42px 20px;
  max-width: 440px;
}

.my-dashboard {
  min-width: 272px;
}
</style>
